
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stable/react-beautiful-dnd",
      function () {
        return require("private-next-pages/stable/react-beautiful-dnd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stable/react-beautiful-dnd"])
      });
    }
  